import defaultImage from '../img/logo-icon-gray.png';

export const scrollToTop = () => {
    if (document.querySelector('.navbar')) {
        document.querySelector('.navbar').scrollIntoView({ behavior: 'smooth' });
    }
};

export const insert = (arr, index, newItem) => {
    return !arr
        ? arr
        : [
              ...arr.slice(0, index),
              newItem,
              ...arr.slice(index),
          ];
};

export const imageLoadError = e => {
    e.target.src = defaultImage;
};
